module.exports = __webpack_public_path__ + "static/3-e72a6a843b796b267500b87f0c50c877.png";